import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);

const initBarriersSlider = () => {
  const slider = document.querySelector(".barriers-slider");

  slider &&
    new Swiper(slider, {
      loop: true,
      spaceBetween: 20,

      breakpoints: {
        997: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
      navigation: {
        nextEl: ".barriers__navigation-next",
        prevEl: ".barriers__navigation-prev",
        disabledClass: "last",
      },
      pagination: {
        el: ".barriers__pagination",
        clickable: true,
        currentClass: "active",
      },
    });
};

export default initBarriersSlider;
